module.exports = {
  ACTIVE_RESEARCHER_PPE: "Active Researchers' PPE",
  ADJACENT_INDIVIDUAL_PPE: "Adjacent Individuals' PPE",
};
